import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.cartMutationObserver();
  }
  
  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);

  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();
    
    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
    */
   customElements.whenDefined('shopify-payment-terms').then(() => {
     const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
     const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }
  
  close() {
    this.closeDialog();
  }
  
  cartMutationObserver() {
    // console.log('cartMutationObserver');
    
    const target = document.querySelector('.cart-drawer__dialog');
    const timerElement = document.querySelector('.cart-reservation-timer');

    if (!target || !timerElement || !(timerElement instanceof HTMLElement)) {
      return;
    }

    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        // Handle 'open' attribute changes
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          if (target.hasAttribute('open')) {
            const id = setTimeout(() => {
              timerElement.style.transform = 'translateX(100%)';
              timerElement.style.marginBottom = '-40px';
              clearTimeout(id);
            }, 3000);
          } else {
            console.log('close');
            timerElement.style.transform = 'translateX(0)';
            timerElement.style.marginBottom = '0';
          }
        }
        
        // Handle subtree modifications (childList changes)
        if (mutation.type === 'childList') {
          // Check if timer element still exists after subtree changes
          const currentTimerElement = document.querySelector('.cart-reservation-timer');
          if (currentTimerElement && currentTimerElement instanceof HTMLElement && target.hasAttribute('open')) {
            // Re-apply timer animation if drawer is open after subtree modification
            const id = setTimeout(() => {
              currentTimerElement.style.transform = 'translateX(100%)';
              currentTimerElement.style.marginBottom = '-40px';
              clearTimeout(id);
            }, 3000);
          }
        }
      }
    });

    // Start observing the target element
    observer.observe(target, {
      attributes: true, // watch for attribute changes
      attributeFilter: ['open'], // only watch the 'open' attribute
      childList: true, // watch for child list changes
      subtree: true // watch for changes in the subtree
    });
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}

